export class LoginError extends Error {
  constructor(error) {
    if(error && error.response && error.response.data){
      super(error.response.data.message);
    }else
      super('Failed to login. Please try again.');
  }
}